import script from "./pick-follow-up-data.vue?vue&type=script&setup=true&lang=js"
export * from "./pick-follow-up-data.vue?vue&type=script&setup=true&lang=js"

import "./pick-follow-up-data.vue?vue&type=style&index=0&id=4c941af4&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4c941af4"]])

export default __exports__